import axios from 'axios';

export const API_URL = `${process.env.REACT_APP_API_URL}api/public/`;
export const API_TENANT = process.env.REACT_APP_TENANT || 'artbanne';

const http = axios.create({
    baseURL: API_URL,
    headers: {
        'x-tenant': API_TENANT,
    },
});

export const Api = {
    getProducts: async function () {
        try {
            return await http.get('products/');
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    getProduct: async function (slug) {
        try {
            return await http.get(`products/getProduct/${slug}`);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    getSuggestedProducts: async function () {
        try {
            return await http.get('products/getSuggestedProducts');
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    getCart: async function (cart) {
        try {
            return await http.get('products/getCart', {
                params: { cart },
            });
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    updateCart: async function (slug) {
        try {
            return await http.get(`products/${slug}`);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    getProductCategories: async function () {
        try {
            return await http.get('categories/');
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
};

export default Api;